"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.autoCompleteBase = void 0;

var _react = _interopRequireDefault(require("react"));

var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Input = require("../Input");

var _excluded = ["margin", "width"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var autoCompleteBase = _objectSpread({}, _Input.inputBaseStyles);

exports.autoCompleteBase = autoCompleteBase;
var useStyles = (0, _makeStyles.default)({
  root: function root(_ref) {
    var width = _ref.width,
        margin = _ref.margin;
    return _objectSpread(_objectSpread({}, autoCompleteBase), {}, {
      width: width,
      margin: margin,
      '& .MuiInputBase-root.MuiFilledInput-root.MuiInputBase-formControl.MuiAutocomplete-inputRoot': {
        minHeight: '56px',
        height: 'auto'
      }
    });
  }
});

var Autocomplete = function Autocomplete(_ref2) {
  var margin = _ref2.margin,
      width = _ref2.width,
      rest = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Autocomplete.default, _extends({
    classes: useStyles({
      width: width,
      margin: margin
    })
  }, rest));
};

var _default = Autocomplete;
exports.default = _default;